import React from "react";
import { Card } from "@fluentui/react-components";
import "./styles.scss";
import { useNavigate } from "react-router-dom";
import InfiniteDropdown from "#root/components/InfiniteDropdown";
import { ROUTES } from '#root/routes/constants';
import { useInfiniteIncidents, useIncidentById } from '#root/queries/incidents';
import { useInfiniteDropdown } from '#root/hooks/useInfiniteDropdown';
import { useVTrackerSelectedIncident } from "#root/queries/local";
import { useInfiniteLocations } from "#root/queries/locations";
import { useInfiniteChiefComplaints } from "#root/queries/chiefComplaints";
import ActionCards from "#root/components/ActionCards";

const VTracker: React.FC = () => {
  const navigate = useNavigate();
  const { selectedIncidentId: vtrackerIncidentId, setVTrackerSelectedIncidentId } = useVTrackerSelectedIncident();


  // Background fetch for offline availability
  useInfiniteIncidents({ take: 1000 });
  useInfiniteLocations({ take: 1000 });
  useInfiniteChiefComplaints({ take: 1000 });

  const {
    selectedId: selectedIncidentId,
    selectedData: selectedIncidentData,
    handleChange: handleIncidentChange,
    setFilter: setIncidentFilter,
    queryResult: incidentQueryResult
  } = useInfiniteDropdown({
    initialId: vtrackerIncidentId || undefined,
    onChange: (id) => setVTrackerSelectedIncidentId(id),
    useInfiniteQuery: useInfiniteIncidents,
    useItemById: useIncidentById
  });

  const actionCards = [
    {
      image: "general-contacts",
      title: "General Contact",
      onClick: () => navigate(ROUTES.VTRACKER.ADD_CONTACT),
    },
    {
      image: "mass-casualty",
      title: "Mass Casualty",
      onClick: () => navigate(ROUTES.VTRACKER.ADD_VICTIM),
    },
    {
      image: "all-contacts",
      title: "All Contacts",
      onClick: () => navigate(ROUTES.VTRACKER.ALL_CONTACTS),
    },
    {
      image: "all-victims",
      title: "All Victims",
      onClick: () => navigate(ROUTES.VTRACKER.ALL_VICTIMS),
    },
    {
      image: "hot-wash",
      title: "Hot Wash",
      onClick: () => navigate(ROUTES.VTRACKER.HOT_WASH),
    },
  ];

  return (
    <div className="vtracker">
      <h2>Select the Incident <div className="divider" /></h2>
      <div className="incident-dropdown">
        <InfiniteDropdown
          value={selectedIncidentId || ''}
          onChange={(_, data) => handleIncidentChange(data.value)}
          onFilterChange={setIncidentFilter}
          queryResult={incidentQueryResult}
          itemToOption={(incident) => ({
            value: incident.id ?? '',
            text: incident.name ?? ''
          })}
          placeholder="Select incident"
          selectedItem={selectedIncidentData}
        />
      </div>
      <ActionCards cards={actionCards} />
    </div>
  );
};

export default VTracker;